import { IListItemAdapter, DefaultListItemAdapter } from './../select-list/select-list.component';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Entity } from '../select-list/select-list.component';
import { Comparison } from '../../comparison';

@Component({
  selector: 'app-multi-select-list',
  templateUrl: './multi-select-list.component.html',
  styleUrls: ['./multi-select-list.component.css']
})
export class MultiSelectListComponent implements OnInit {

  @Input() items: Entity[];
  @Input() selectedItems: Entity[] = [];
  @Output() selectedItemsChange = new EventEmitter<any>();

  @Input() public adapter: IListItemAdapter = new DefaultListItemAdapter();

  filter: string;

  constructor() { }

  ngOnInit() {
  }

  onFilterKey(evt: KeyboardEvent) {
    if (evt.keyCode == 27)//escape key
      this.filter = "";
  }

  get matchingItems() {
    if (!this.filter || this.filter.length < 1)
      return this.items;

    return this.items.filter(x => this.matchesFilter(x));
  }

  matchesFilter(item) {
    return this.adapter.getText(item).toLowerCase().indexOf(this.filter.toLowerCase()) >= 0;
  }

  contains(item) {
    return Comparison.contains(this.selectedItems, item);
  }

  lastItemClicked;

  get allAreSelected() {
    if (!this.selectedItems)
      return false;
    return this.selectedItems.length > 0 && this.selectedItems.length == this.items.length;
  }

  get noneAreSelected() {
    return !this.selectedItems || this.selectedItems.length === 0;
  }

  get checkboxState() {
    if (this.allAreSelected)
      return true;
    if (this.noneAreSelected)
      return false;
    return null;
  }

  onSelectAllChange(event) {
    if (!this.allAreSelected) {
      this.selectAll();
    }
    else {
      this.selectedItems = [];
      this.selectedItemsChange.emit(this.selectedItems);
    }
  }

  selectAll() {
    this.selectedItems = this.items.map(x => x);
    this.selectedItemsChange.emit(this.selectedItems);
  }

  onSelectionChange(item, event) {

    if (event.shiftKey && this.lastItemClicked) {

      let a = this.adapter.indexOf(this.items, this.lastItemClicked);
      let b = this.adapter.indexOf(this.items, item);
      if (a > b) {
        let x = a;
        a = b;
        b = x;
      }
      console.log("a and b", { a: a, b: b });

      let items = this.selectedItems.map(x => x);

      for (let i = a; i <= b; i++) {
        if (this.adapter.indexOf(this.selectedItems, this.items[i]) == -1 && this.matchesFilter(this.items[i])) {
          items.push(this.items[i]);
        }
      }

      this.selectedItems = items;
      this.lastItemClicked = null;
    }
    else {
      this.lastItemClicked = null;

      if (!this.selectedItems) {
        this.selectedItems = [item];
      }
      else {
        let index = this.adapter.indexOf(this.selectedItems, item);

        console.log("premap: " + JSON.stringify(this.selectedItems));
        let items = this.selectedItems.map(x => x);

        if (index < 0) {
          items.push(item);
          this.lastItemClicked = item;
        }
        else
          items.splice(index, 1);

        this.selectedItems = items;
      }
    }

    this.selectedItemsChange.emit(this.selectedItems);
  }
}
